import { createFileRoute, redirect } from "@tanstack/react-router";
import { LaunchCampaignTemplate } from "~/features/launchCampaign/LaunchCampaignTemplate";
import {
  markLaunchCampaignIntroShown,
  shouldShowLaunchCampaignIntro,
} from "~/utils/launchCampaignIntro";

export const Route = createFileRoute("/_authenticated/launch-campaign")({
  beforeLoad: () => {
    // 表示済み（sessionStorage）にも関わらずこの URL に来た場合（戻る操作・直接アクセス等）は
    // 再生せず discover へ逃がす。
    if (!shouldShowLaunchCampaignIntro()) {
      throw redirect({ to: "/discover", replace: true });
    }
    markLaunchCampaignIntroShown();
  },
  component: LaunchCampaignTemplate,
});
